// src/components/LikeDislikeButtons.jsx
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const LikeDislikeButtons = ({ gameId }) => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;

  const [liked, setLiked] = useState(null); // 1 = liked, -1 = disliked
  const [loading, setLoading] = useState(false);

  const handleLike = async (value) => {
    if (loading) return;

    if (!userId) {
      return navigate("/login");
    }

    setLoading(true);
    try {
      await axios.post("/api/user-game-preferences", {
        user_id: userId,
        game_id: gameId,
        liked: value,
      });
      setLiked(value);
    } catch (err) {
      console.error("Failed to save rating:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-3 text-center">
      <p className="text-sm text-gray-600 mb-2">Have you played this game?</p>
      <div className="flex justify-center space-x-6">
        <button
          onClick={() => handleLike(1)}
          className={`text-2xl transition ${
            liked === 1 ? "text-green-600" : "text-gray-400 hover:text-green-500"
          }`}
          disabled={loading}
          title="Like"
        >
          👍
        </button>
        <button
          onClick={() => handleLike(-1)}
          className={`text-2xl transition ${
            liked === -1 ? "text-red-600" : "text-gray-400 hover:text-red-500"
          }`}
          disabled={loading}
          title="Dislike"
        >
          👎
        </button>
      </div>
    </div>
  );
};

export default LikeDislikeButtons;
